import PlaceholderArt from '../../src/legacy/PlaceholderArt';
export default PlaceholderArt;
